import script from "./status-startup-application.vue?vue&type=script&setup=true&lang=ts"
export * from "./status-startup-application.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__